import { Instagram } from "lucide-react";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-[#5EA2FF]/15 bg-[#020711] px-6 py-14 sm:px-12 lg:px-20">
    <Reveal>
      <p
        data-testid="footer-disclaimer"
        className="max-w-3xl text-xs leading-relaxed text-[#7A90B8]"
      >
        <span className="font-mono tracking-[0.2em] text-[#5EA2FF]">AVISO LEGAL — </span>
        BC TRADES ofrece contenido exclusivamente educativo y formativo. El trading en
        mercados financieros conlleva un alto riesgo de pérdida de capital y no es
        adecuado para todos los perfiles. Nada de lo publicado en esta página constituye
        asesoramiento financiero ni garantiza resultados. Rentabilidades pasadas no
        garantizan rentabilidades futuras.
      </p>
    </Reveal>
    <div className="mt-10 flex flex-col gap-6 border-t border-[#5EA2FF]/10 pt-8 font-mono text-[11px] tracking-[0.25em] text-[#7A90B8] sm:flex-row sm:items-center sm:justify-between">
      <span data-testid="footer-copy">© 2026 BC TRADES — POL &amp; EDGAR</span>
      <a
        data-testid="footer-instagram-link"
        href="https://instagram.com/bctrades__"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-2 text-[#DCE8FF] transition-colors hover:text-[#5EA2FF]"
      >
        <Instagram className="h-4 w-4" />
        @BCTRADES__
      </a>
      <span>HECHO CON DISCIPLINA</span>
    </div>
  </footer>
);
